export default "__VITE_ASSET__DGuAIkwk__"